// extracted by mini-css-extract-plugin
export default {"info":"RegisterPage_info__ZpmA7","link":"RegisterPage_link__xBRdc","container":"RegisterPage_container__GLcX3","landingSection":"RegisterPage_landingSection__FEp3U"};